<span matSnackBarLabel>
  <app-highlighted-message [text]="text" [highlights]="highlights" />
</span>

<span matSnackBarActions>
  <button
    matRipple
    matSnackBarAction
    class="close-button"
    (click)="snackBarRef.dismissWithAction()"
  >
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>
</span>
